import { render } from "./VerifyVetLicense.vue?vue&type=template&id=e865d20e&scoped=true"
import script from "./VerifyVetLicense.vue?vue&type=script&lang=js"
export * from "./VerifyVetLicense.vue?vue&type=script&lang=js"

import "./VerifyVetLicense.vue?vue&type=style&index=0&id=e865d20e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e865d20e"]])

export default __exports__